// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__6IBJ0","icon":"mimic___styles_icon__nIBFZ"};